import { ADD_RESPONSES, FETCHING_RESPONSES, FETCHED_RESPONSES, CLEAR_ALL, IS_LOGGED_OUT, SET_ACCOUNT, SET_CURRENT_ACCOUNT, UPDATE_USER } from '../constants';

interface ResponsesState {
  accountId: string | null;
  cognitoId: string | null;
  list: Record<string, any[]>;
  fetching: boolean;
  /** project_id -> timestamp (serializable); used to skip refetch when already loaded */
  fetched: Record<string, number>;
}

const initialState: ResponsesState = {
  accountId: null,
  cognitoId: null,
  list: {},
  fetching: false,
  fetched: {},
};

export default function responsesReducer(
  state = initialState,
  { type, payload, meta }: { type: string; payload?: any; meta?: { accountId: string; cognitoId: string } }
): ResponsesState {
  switch (type) {
    case CLEAR_ALL:
    case IS_LOGGED_OUT:
      return initialState;
    case SET_ACCOUNT:
    case SET_CURRENT_ACCOUNT: {
      const accountId = payload?.account_id ?? null;
      if (accountId === state.accountId) return state;
      return { ...initialState, accountId, cognitoId: state.cognitoId };
    }
    case UPDATE_USER:
    case 'UPDATE_AUTH_USER': {
      const cognitoId = payload?.cognito_id ?? null;
      if (cognitoId === state.cognitoId) return state;
      return { ...initialState, accountId: state.accountId, cognitoId };
    }
    case ADD_RESPONSES:
      return {
        ...state,
        list: { ...state.list, [payload.project_id]: payload.list },
      };
    case FETCHING_RESPONSES: {
      const scopedState = meta && (state.accountId !== meta.accountId || state.cognitoId !== meta.cognitoId)
        ? { ...initialState, accountId: meta.accountId, cognitoId: meta.cognitoId }
        : state;
      return { ...scopedState, fetching: payload };
    }
    case FETCHED_RESPONSES:
      return { ...state, fetched: { ...state.fetched, [payload.project_id]: Date.now() } };
    default:
      return state;
  }
}
